import { render, staticRenderFns } from "./SafteElectronic.vue?vue&type=template&id=0101c8b6&scoped=true&"
import script from "./SafteElectronic.vue?vue&type=script&lang=js&"
export * from "./SafteElectronic.vue?vue&type=script&lang=js&"
import style0 from "./SafteElectronic.vue?vue&type=style&index=0&id=0101c8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0101c8b6",
  null
  
)

export default component.exports